export default {"src":"/_next/static/media/michael.2241e180.svg","height":554,"width":511,"blurWidth":0,"blurHeight":0};